import { labelFonti, labelNoSource } from "_constants";

export const HeaderCardSourcesTotalProject = ({
  codesSourceTotal,
  archiveSourceTotal,
  privateSourceTotal,
}: {
  codesSourceTotal: number;
  archiveSourceTotal: number;
  privateSourceTotal: number;
}) => {
  return (
    <div className="sub-header">
      <div className="container-chip">
        {codesSourceTotal > 0 && <div className="chip chip-codici"></div>}
        {archiveSourceTotal > 0 && <div className="chip chip-archivio"></div>}
        {privateSourceTotal > 0 && <div className="chip chip-privato"></div>}
      </div>
      {archiveSourceTotal + codesSourceTotal + privateSourceTotal > 0 ? (
        <span
          className={`blue font-weight-700 ${
            archiveSourceTotal + codesSourceTotal + privateSourceTotal > 0
              ? "margin-left-4"
              : ""
          }`}
        >
          {archiveSourceTotal +
            codesSourceTotal +
            privateSourceTotal +
            " " +
            labelFonti}
        </span>
      ) : (
        <span className="italic blue font-weight-400">{labelNoSource}</span>
      )}
    </div>
  );
};
